import React from 'react';
import './extra-text.css';

const Who = (props) => {
  return <section className="extra">
    <h1>Chi c'è dietro ad elezioni.io?</h1>
    <div className="text-body">
      <p><a href="https://twitter.com/littleark">Carlo Zapponi</a> e <a href="https://twitter.com/simonelippolis">Simone Lippolis</a>. Lo abbiamo fatto per passione e per curiosità. Non abbiamo alcuno sponsor, istituzionale o occulto. Se volete saperne un po' più su di noi potete visitare la pagina "<a href="https://2018.elezioni.io/leggi/chi-siamo#/leggi/chi-siamo">Chi siamo</a>".</p>
    </div>
    </section>
}

export default Who;



// WEBPACK FOOTER //
// ./src/elezioni/components/Layout/Who.js